"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemLabel = exports.Li = exports.Ul = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Ul = styled_components_1.default.ul `
  list-style-type: none;
  margin: 0;
  padding: 0;
  ${({ footer, theme }) => footer
    ? `
    flex-shrink: 1;
    border-top: 1px solid ${theme.ui01};
  `
    : `
    flex-grow: 1;
    overflow: auto;
  `}
`;
exports.Li = styled_components_1.default.li `
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.body01};
  margin: ${({ theme }) => `${theme.spacing03} 0;`};
`;
exports.MenuItemLabel = styled_components_1.default.div `
  padding: 6px 0;
`;
